<div class="block-schedule__top">
    <h1>{{ 'SCHEDULE_TITLE' | translate }}</h1>
    <p>{{ 'SCHEDULE_DESCRIPTION' | translate }}</p>

    <a
        [routerLink]="'/schedule/search' | localize"
        class="btn--link btn btn--maximal btn--primary btn--big btn--icon margin-bottom-10 link--no-line link--no-hover">
        <span>{{ 'SCHEDULE_SEARCH_LINE_STOP' | translate }}</span>
    </a>

    <a
        *ngIf="!env.MAP.HIDE_JOURNEY_PLANNER"
        [routerLink]="'/schedule/planner' | localize"
        class="btn--link btn btn--maximal btn--primary btn--big btn--icon link--no-line link--no-hover">
        <span>{{ 'SCHEDULE_PLAN_ROUTE' | translate }}</span>
    </a>
</div>
